import DiagramContextComponent from 'component/Survey/Create/Logic/Jump/Diagram/Context'

function DiagramContainer() {
    return <DiagramContextComponent/>
}

export default DiagramContainer